"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Decompose = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M3 12a3 3 0 110 6 3 3 0 010-6zm12 0a3 3 0 110 6 3 3 0 010-6zM3 13.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm12 0a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm-3.24-6.156l.757 1.228.094-.34c.09-.322.418-.524.76-.485l.103.018c.342.088.56.399.522.72l-.02.098-.539 1.926c-.09.323-.418.525-.76.486l-.103-.019-2.048-.525c-.377-.096-.602-.462-.503-.817.09-.322.418-.524.76-.486l.103.02.36.09-.755-1.227a.665.665 0 01.268-.939c.35-.19.799-.077 1.001.252zm-5.52 0c.202-.329.65-.442 1-.252.351.19.471.61.269.94l-.756 1.227.361-.092.103-.019c.342-.038.67.164.76.486.099.355-.126.72-.503.817l-2.048.525-.103.02c-.342.038-.67-.164-.76-.487l-.54-1.926-.019-.097a.675.675 0 01.522-.72l.103-.02c.342-.038.67.164.76.487l.094.339zM9 0a3 3 0 110 6 3 3 0 010-6z",
  fill: "#ACB3BE",
  fillRule: "nonzero",
  className: "fill"
}));

var _default = Decompose;
exports.default = _default;